module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C152"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("By way of introduction . . .")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "C154"
  }, [_vm._v("To encounter the quantum is to feel like an explorer from a faraway land who has come for the first time upon an automobile. It is obviously meant for use, and important use, but what use?")]), _vm._v(" "), _c('p', {
    staticClass: "C155",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("John Archibald Wheeler")]), _vm._v(" "), _c('p', {
    staticClass: "C154"
  }, [_vm._v("Somewhere in [quantum theory] the distinction between reality and our knowledge of reality has become lost, and the result has more the character of medieval necromancy than of science.")]), _vm._v(" "), _c('p', {
    staticClass: "C155",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Edwin Jaynes")]), _vm._v(" "), _c('p', {
    staticClass: "C154"
  }, [_vm._v("We must never forget that ‘reality’ too is a human word just like ‘wave’ or ‘consciousness’. Our task is to learn to use these words correctly – that is, unambiguously and consistently.")]), _vm._v(" "), _c('p', {
    staticClass: "C155",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Niels Bohr")])]), _c('p', {
    staticClass: "C154"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("[")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Quantum mechanics] is a peculiar mixture describing in part realities of Nature, in part incomplete human information about Nature – all scrambled up by Heisenberg and Bohr into an omelette that nobody has seen how to unscramble.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "C155",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Edwin Jaynes")]), _vm._v(" "), _c('p', {
    staticClass: "C154"
  }, [_vm._v("Arguably the most important lesson of quantum mechanics is that we need to critically revisit our most basic assumptions about nature.")]), _vm._v(" "), _c('p', {
    staticClass: "C155",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Yakir Aharonov et al.")]), _vm._v(" "), _c('p', {
    staticClass: "C154"
  }, [_vm._v("I hope you can accept Nature as she is – absurd.")]), _vm._v(" "), _c('p', {
    staticClass: "C156",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Richard Feynman")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09598534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/03_By_way_of_introduction.vue
// module id = 66
// module chunks = 0